import { combineReducers } from 'redux';

import { reducer as list } from './listModule';
import { reducer as update } from './updateModule';
import { reducer as taxExemptReasons } from './taxExemptReasonsModule';

export default combineReducers({
	update,
	list,
	taxExemptReasons,
});
